module.exports = require('./helpers/bundle-url').getBundleURL('1DUm8') + "Paras_logo.50f44cc1.svg";